import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import GenerePdf from './GenerePdf';
import IBAN from 'iban';

const PrelevementSepaForm = ({ nb_fois, code, setSuccessPaiement }) => {

    const url = localStorage.getItem('url');
    const [goGenerePdf, setGoGenerePdf] = useState(false);

    const [adherent, setAdherent] = useState({
        prenom_adherent: '', nom_adherent: '', adresse1: '', adresse2: '', code_postal: '', ville: '', telephone: '', numero_de_portable: '', e_mail_1: '', e_mail_2: '',
        e_mail_3: '', civilite: 'M', code: '', bic: '', iban: '', rum: '', ibantmp: '', bictmp: ''
    });

    const [formattedIBAN, setFormattedIBAN] = useState('');


    const [fin, setFin] = useState(false);

    useEffect(() => {
        console.log('useEffect code:', code);
        if (code && code !== '')
            fetch(`${url}GetAdherentByCode/${code}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    let adh = data.data[0];
                    //iban', required: true },
                    // { lib: 'bic', required: true },
                    // { lib: 'rum
                    console.log('Réponse du serveur:', adh)
                    setAdherent({ ...adh, ibantmp: '', iban: '', bictmp: '', bic: '', nb_fois: nb_fois, code: code, type_paiement: 'prélèvement' });
                })
                .catch(error => console.error('Erreur:', error));
    }, [code]);

    const handleSaveIban = () => {
        let adh = 
        { ...adherent, fichier: "mandat_sepa", type_paiement: adherent.nb_fois === 1 ? 'Paiement ponctuel' : 'Paiement récurrent', mailto: adherent.e_mail_1, subject: 'Prélèvement SEPA FFC MOBILITE', corps: 'Bonjour,<br /><br />Veuillez trouver ci-joint le mandat SEPA à transmettre à votre banque.<br /><br />Cordialement,<br /><br />L\'équipe FFC MOBILITE' };
        fetch(`${url}SaveIban`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            // remplace 'Invalid date' par '' dans le JSON
            body: JSON.stringify(adh)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                // setTimeout(() => {
                //     setGoGenerePdf(true);
                // }, 500);
                setSuccessPaiement(true);
            })
            .catch(error => console.error('Erreur:', error));
    }

    const isValidBICNumber = (input) => {
        var res = /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(input.toUpperCase());
        return res;
    }

    //https://stackoverflow.com/questions/21928083/iban-validation-check
    const isValidIBANNumber = (input) => {
        var CODE_LENGTHS = {
            AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
            CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
            FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
            HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
            LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
            MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
            RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
        };
        var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
            code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
            digits;
        // check syntax and length
        if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
            return false;
        }
        // rearrange country code and check digits, and convert chars to ints

        digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
            var res = letter.charCodeAt(0) - 55;
            return res.toString();
        });

        // digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        //     return letter.charCodeAt(0) - 55;
        // });
        // final check
        return mod97(digits) === 1;
    }

    const mod97 = (string) => {
        var checksum = string.slice(0, 2), fragment;
        for (var offset = 2; offset < string.length; offset += 7) {
            fragment = String(checksum) + string.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    }


    const handleInputChange = (field, value) => {
        setAdherent({ ...adherent, [field]: value });
    };

    return (
        <div>
            {!fin && (<>
                <h1>Prélèvement SEPA</h1>
                <GenerePdf fichier="mandat_sepa" data={adherent} go={goGenerePdf} setGo={setGoGenerePdf} visible={false} />

                <Card>
                    <Card.Header>Prélèvement SEPA</Card.Header>
                    <Card.Body>
                        <Row xs={1} md={2} className="g-4">
                            <Col>
                                <Card>
                                    <Card.Header>Débiteur</Card.Header>
                                    <Card.Body>
                                        {adherent.forme_juridique_de_la_societe} {adherent.nom_de_l_entreprise}<br />
                                        {adherent.civilite} {adherent.prenom_adherent} {adherent.nom_adherent}<br />
                                        {adherent.adresse1}
                                        {adherent.adresse2}<br />
                                        {adherent.code_postal}&nbsp;
                                        {adherent.ville}
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card>
                                    <Card.Header>Créancier</Card.Header>
                                    <Card.Body>
                                        FFC MOBILITE REPARATION ET SERVICES<br />
                                        Immeuble Le Cardinet<br />
                                        8 rue Bernard Buffet<br />
                                        75017 PARIS<br />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                        <h5>Identifiant du Créancier : FR40ZZZ420755</h5>
                        <h5>Référence du mandat (RUM) : {adherent.rum}</h5>
                        <br />
                        <InputGroup className={`mb-3 ${adherent.iban.length === 0 ? 'has-error' : ''}`}>
                            <InputGroup.Text className={isValidIBANNumber(adherent.iban) ? '' : 'border-danger'}>
                                IBAN<span style={{ color: 'red' }}>&nbsp;*</span>
                            </InputGroup.Text>
                            <FormControl
                                value={formattedIBAN}
                                onChange={(e) => {
                                    const inputIBAN = e.target.value;
                                    setFormattedIBAN(IBAN.printFormat(inputIBAN));
                                    // Vérifiez si l'IBAN entré est valide avant de le mettre à jour
                                    if (IBAN.isValid(inputIBAN)) {
                                        handleInputChange('iban', inputIBAN);
                                    } else {
                                        handleInputChange('iban', '');
                                    }
                                }}
                            />
                        </InputGroup>
                        <InputGroup className={`mb-3 ${isValidBICNumber(adherent.bic) ? '' : 'has-error'}`}>
                            <InputGroup.Text className={isValidBICNumber(adherent.bic) ? '' : 'border-danger'}>
                                BIC<span style={{ color: 'red' }}>&nbsp;*</span>
                            </InputGroup.Text>
                            <FormControl
                                value={adherent.bic}
                                onChange={(e) => handleInputChange('bic', e.target.value)}
                            />
                        </InputGroup>
                    </Card.Body>
                </Card >

                <div style={{ marginBottom: '10px' }}>
                    {/* Add a message to inform that required fields are mandatory */}
                    <p style={{ color: 'red' }}>Les champs marqués d'une * sont obligatoires.</p>
                </div>
                <div className="d-grid gap-2">
                    <Button variant="primary" size='lg' onClick={handleSaveIban} disabled={!(isValidIBANNumber(adherent.iban) && isValidBICNumber(adherent.bic))}>Enregistrer</Button>
                </div>
                {/* <AdherentNewUpdate handleSaveAdherent={handleSaveAdherent} blocs={blocs} champs={champs} adherent={adherent} cotisation={{}} /> */}
            </>)}
            {fin && (<>
                <Alert variant='success'>
                    Merci !! Votre adhésion a bien été enregistrée.
                </Alert>
            </>)}
        </div >
    );
}

export default PrelevementSepaForm;


